<template>
  <div>
    <h2>Мы полностью соблюдаем законодательство РФ. Со всеми документами вы можете ознакомиться заранее:</h2>
    <div class="pdfLink">
      <pdfLink
        :href="'https://finmoll.ru/upload/uf/1f0/u29t0t57wl188rpfannw14aygckiuv89.pdf'"
        :title="'Правила предоставления микрозаймов'"
      ></pdfLink>
      <pdfLink
        :href="'https://finmoll.ru/backend/content/documents/microloan_terms_conditions'"
        :title="'Общие условия договора микрозайма'"
      ></pdfLink>
      <pdfLink
      :href="'https://finmoll.ru/backend/content/documents/microloan_providing_info'"
      :title="'Информация об условиях предоставления, использования и возврата потребительского займа'"
    ></pdfLink>
      <pdfLink
        :href="'/admd/pdf/informaciyaDlyaPoluchatelejFinansovojUslugi.pdf'"
        :title="'Информация для получателей финансовой услуги'"
      ></pdfLink>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Repayment",
    components: {
      pdfLink: () => import('@/components/chunk/pdfLink'),
    }
  }
</script>

<style scoped>

</style>
